import React, { useContext } from "react";
import Background from "../Background/Background";
import { Context } from "../../context/Context";
import Select from "../Inputs/Select/Select";

export default function Theme() {
  const { state ,handleUpdate} = useContext(Context);

  return (
    <>
      <p className="font-semibold text-gray-800 flex items-center text-lg">
        <span className="text-xl ri-paint-fill font-medium "></span>&nbsp; Theme
        Settings
      </p>
      <div className="mt-5 w-full">
        <span className="text-sm text-gray-600 font-medium mb-3 inline-block">
          CODE THEME
        </span>
        <br />
        <Select
          w="w-full"
          options={state.theme.codeTheme}
          handleUpdate={handleUpdate}
          tree={["theme", "codeTheme"]}
          id={"CodeTheme"}
        />
      </div>
      <div className="mt-5 w-full">
        <span className="text-sm text-gray-600 font-medium mb-3 inline-block">
          LANGUAGE
        </span>
        <br />
        <Select
          w="w-full"
          options={state.theme.codeLang}
          id={"CodeLang"}
          tree={["theme", "codeLang"]}
          handleUpdate={handleUpdate}
        />
      </div>
      <Background />
    </>
  );
}
